import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
  imports: [FontAwesomeModule],
})
export class LoadingComponent {
  @Input() size: SizeProp = '3x';
  @Input() centered: boolean = true;
  faSpinner = faSpinner;
}
